import {useDispatch} from 'react-redux';

import {
  businessCaseApi,
  CorrectiveTaxDocumentRequestBody,
  useCreateFullCorrectiveTaxDocumentMutation,
  useCreatePartialCorrectiveTaxDocumentMutation,
} from '@dms/api/sales';

import {handleApiError} from '../utils/handleApiError';

export type SubmitCorrectiveTaxDocumentArgs = {
  businessCaseId: string;
  orderId: string;
  paymentId: string;
  type: 'full' | 'partial';
  requestBody: CorrectiveTaxDocumentRequestBody;
  onSuccess: () => void;
};

export const useSubmitCorrectiveTaxDocument = () => {
  const dispatch = useDispatch();
  const [createFullCorrectiveTaxDocument] = useCreateFullCorrectiveTaxDocumentMutation();
  const [createPartialCorrectiveTaxDocument] = useCreatePartialCorrectiveTaxDocumentMutation();

  const submitCorrectiveTaxDocument = async ({
    businessCaseId,
    orderId,
    paymentId,
    type,
    requestBody,
    onSuccess,
  }: SubmitCorrectiveTaxDocumentArgs) => {
    const createDocumentMutation =
      type === 'full' ? createFullCorrectiveTaxDocument : createPartialCorrectiveTaxDocument;

    await createDocumentMutation({
      businessCaseId,
      orderId,
      paymentId,
      correctiveTaxDocumentRequestBody: requestBody,
    })
      .unwrap()
      .then(() => {
        dispatch(
          businessCaseApi.util.invalidateTags([
            {type: 'BusinessCaseActions', id: businessCaseId},
            {type: 'BusinessCaseDetail', id: businessCaseId},
          ])
        );
        onSuccess();
      })
      .catch(handleApiError);
  };

  return [submitCorrectiveTaxDocument] as const;
};
